import React from 'react';
import _ from 'lodash';

import { TimeSeriesPoint, useLoadTabLazyQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import * as types from './types';



export interface IDaemonTimeSeries {
  title: string;
  series: IPoint[];
}

export interface IPoint {
  x: string;
  y: number;
}

export interface IData {
  daemonTimeSeries: IDaemonTimeSeries[];
  orderCountTimeSeries: IPoint[];
}

export function useQuery() {
  const [fnQuery, tuple] = useLoadTabLazyQuery({
    fetchPolicy: 'network-only'
  });

  const wrappedTuple = React.useMemo(
    () => {
      const data: IData = {
        daemonTimeSeries: [
          {
            title: "Cache Sales Orders",
            series: __makeSeries(tuple.data?.cacheSalesOrdersTimeSeries.series ?? [])
          },
          {
            title: "Process Sales Order Cache",
            series: __makeSeries(tuple.data?.processSalesOrderCacheTimeSeries.series ?? [])
          },
          {
            title: "Check for Updates to Unfulfilled Orders",
            series: __makeSeries(tuple.data?.wooCommerceCheckForUpdatesToUnfulfilledOrdersTimeSeries.series ?? [])
          }
        ],
        orderCountTimeSeries: _.map(tuple.data?.orderCountTimeSeries.series, (s): IPoint => ({
          x: DateTime.fromISO(s.x).toFormat('MM-dd HH:mm'),
          y: s.y
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );

  const wrappedQuery = React.useCallback(
    (formState: types.IFormState) => {
      return fnQuery({
        variables: {
          start: DateTime.fromJSDate(formState.startDate).startOf('day').toISO() as string,
          end: DateTime.fromJSDate(formState.endDate).endOf('day').toISO() as string
        }
      });
    },
    [fnQuery]
  );

  return [
    wrappedQuery,
    wrappedTuple
  ] as const;
}



function __makeSeries(series: TimeSeriesPoint[]) {
  return _.map(series, (pt): IPoint => ({
    x: DateTime.fromISO(pt.x).toFormat('MM-dd HH:mm'),
    y: pt.y
  }));
}
